<template>
    <div class="loader-div">
        <div class="loader">
            <span class="loader-txt">{{ LoaderText }}</span>
            <i class="fa fa-spinner fa-spin"></i>
        </div>
    </div>
    <div class="bgdiv"></div>
</template>
<script>
export default {
    props: ["LoaderText"],
    data() {
        return {
            txt: "Loading Please wait..",
        };
    },
};
</script>
<style scoped>
.loader-div {
    position: fixed;
    top: 0px;
    z-index: 99999;
}

.bgdiv {
    position: fixed;
    background-color: #00000066;
    display: block;
    width: 100vw;
    height: 100vh;
    top: 0px;
    z-index: 9999;
}

.loader {
    position: fixed;
    padding: 10px;
    top: 25%;
    left: 0;
    right: 0;
    text-align: center;
}

.loader .fa {
    font-size: 85px;
    color: rgba(255, 255, 255, 0.575);
    z-index: 99999;
}

.loader-txt {
    position: relative;
    display: block;
    color: white;
    font-size: 22px;
}
</style>
